import React, { useState } from "react";

import image from "./assets/Mazin.jpg";
import "../Styles/landing.css";
import SignupLogin from "./SignupLogin";
import Profile from "./Profile";

function Landing() {
  const [signedIn, setSignedIn] = useState(false);
  // let signedIn = false;
  return (
    <>
      {signedIn ? (
        <Profile />
      ) : (
        <div className="landing-content row ">
          <p className="col-xs-12 col-sm-5 col-md-5 col-lg-3 col-xlg-6">
            <figure class="text-center">
              <blockquote class="blockquote">
                {/* <p>A well-known quote, contained in a blockquote element.</p> */}
                <p className="">
                  Anything is learnable. Just <cite>use</cite> it or loose it.
                  Got that?
                </p>
              </blockquote>
              <figcaption class="blockquote-footer">
                Mazin Salih | <cite title="Source Title">Learnish</cite>
              </figcaption>
            </figure>
          </p>
          <div class="shadow p-4 mb-5 bg-body rounded col-xs-12 col-sm-5 col-md-5 col-lg-3 col-xlg-6">
            <SignupLogin />
          </div>
        </div>
      )}
    </>
  );
}

export default Landing;
